import { UrlMapper } from "@playroomkit/pr-common";
import { createContext, useContext } from "react";

const URLMapperContext = createContext<UrlMapper | null>(null);

export const useUrlMapper = () => {
    const context = useContext(URLMapperContext);
    if(!context) {
        throw new Error("useUrlMapper must be used within a ManagerProvider");
    }

    return context;
};

export { URLMapperContext }